// extracted by mini-css-extract-plugin
export default {"itemeach":"BtnToAction_itemeach__CrrgX","iconpart":"BtnToAction_iconpart__XLnHr"};